// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Tour/TourTable.jsx

import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import '../../css/TypeServicesForm.css'; // ปรับ path ตามโครงสร้างของคุณ
import 'bootstrap/dist/css/bootstrap.min.css';
import ConfirmationModal from '../ConfirmationModal';

const TourTable = ({ tourData, onEditTour, onDelete, searchQuery, pageLength }) => {
  const dataTableRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTourId, setSelectedTourId] = useState(null);

  const handleDeleteClick = (tourId) => {
    setSelectedTourId(tourId);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    onDelete([selectedTourId]);
    setShowDeleteModal(false);
  };

  useEffect(() => {
    // ทำลาย DataTable เก่าก่อนสร้างใหม่ เพื่อป้องกันการซ้อนทับ
    if ($.fn.dataTable.isDataTable(dataTableRef.current)) {
      $(dataTableRef.current).DataTable().destroy();
    }

    const dataTable = $(dataTableRef.current).DataTable({
      data: tourData,
      pageLength: pageLength,
      lengthChange: false,
      // >>> ปรับ columns ให้ตรงกับโครงสร้าง JSON ใหม่
      columns: [
        {
          title: 'No.',
          data: null, // ไม่ผูกกับข้อมูลโดยตรง
          render: (data, type, row, meta) => meta.row + meta.settings._iDisplayStart + 1,
          orderable: false,
        },
        {
          data: 'tour_Image', // ใช้ key ของ array รูปภาพ
          title: 'Image',
          orderable: false,
          render: (tour_Image) => {
            // ดึง URL รูปภาพแรกจาก Array, ถ้าไม่มีให้ใช้รูปภาพสำรอง
            const imageUrl = (tour_Image && tour_Image.length > 0 && tour_Image[0].resize_url)
              ? tour_Image[0].resize_url
              : 'https://afaa.website/s/9c25ab.svg';
            return `<img src="${imageUrl}" alt="Tour Image" style="width: 70px; height: auto; object-fit: cover;" 
                      onerror="this.onerror=null; this.src='https://afaa.website/s/9c25ab.svg';" />`;
          }
        },
        { data: 'tour_NamePackage', title: 'Package Name' },
        { data: 'tour_Code', title: 'Tour Code' },
        { 
          data: 'tour_Price', 
          title: 'Price',
          render: (price) => {
            // จัดรูปแบบราคาให้มี comma
            return price ? new Intl.NumberFormat('en-US').format(price) : 'N/A';
          }
        },
        { 
          data: 'Date_Departure', 
          title: 'Departure Date',
          render: (date) => {
            // จัดรูปแบบวันที่ให้อ่านง่ายขึ้น (ถ้าต้องการ)
            return date ? new Date(date).toLocaleDateString('en-GB') : 'N/A';
          }
        },
        {
          data: null, // ไม่ผูกกับข้อมูลโดยตรง
          title: 'Actions',
          orderable: false,
          render: (data, type, row) => `
            <i class="fas fa-pen-to-square edit-icon btn-dark" data-id="${row.travel_ID}"></i>
            <i class="fas fa-trash delete-icon btn-dark" data-id="${row.travel_ID}"></i>
          `
        },
      ],
      // <<< ใช้ travel_ID ในการเรียงลำดับเริ่มต้น (ถ้าต้องการ)
      order: [[2, 'asc']], // เรียงตาม Package Name เริ่มต้น
      ordering: true,
      dom: "<'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      pagingType: "full_numbers",
      language: {
        paginate: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      initComplete: function () {
        this.api().on('draw', function () {
          const pagination = $('.dataTables_paginate');
          pagination.addClass('pagination-dark justify-content-end');
          pagination.find('a').addClass('page-link');
          pagination.find('span').addClass('page-item');
        });
      },
    });

    dataTable.search(searchQuery).draw();

    $(dataTableRef.current).on('click', '.delete-icon', function () {
      // แปลง id เป็น number เพื่อความปลอดภัย
      const tourId = parseInt($(this).data('id'), 10);
      handleDeleteClick(tourId);
    });

    $(dataTableRef.current).on('click', '.edit-icon', function () {
      const tourId = parseInt($(this).data('id'), 10);
      onEditTour(tourId);
    });

    return () => {
      // ไม่ต้องทำลาย DataTable ที่นี่อีก เพราะเราทำลายที่จุดเริ่มต้นของ useEffect แล้ว
    };
  }, [tourData, searchQuery, pageLength, onEditTour, onDelete]);

  return (
    <div className="table-responsive">
      <table ref={dataTableRef} className="table table-hover"></table>
      <ConfirmationModal
        isOpen={showDeleteModal}
        message={"Are you sure you want to delete this tour package?"}
        onConfirm={confirmDelete}
        onCancel={() => setShowDeleteModal(false)}
      />
    </div>
  );
};

export default TourTable;